import React, { useEffect } from 'react';
import { Box, Container } from '@mui/material';
import { useCodeViewer } from '../hooks/useCodeViewer';
import { CodeViewer } from '../components/CodeViewer/CodeViewer';

/**
 * CodeViewerPage
 *
 * Standalone page for viewing and interacting with generated training code.
 * Similar to 2D/3D visualization pages, this is a dedicated view for the code.
 */
export const CodeViewerPage: React.FC = () => {
  const {
    code,
    isLoading,
    error,
    modelType,
    configPath,
    requestCode,
    copyToClipboard,
    downloadCode,
  } = useCodeViewer();

  // Request code on component mount
  useEffect(() => {
    requestCode();
  }, [requestCode]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100%',
        backgroundColor: '#0d0d0d',
        overflow: 'hidden',
      }}
    >
      {/* Main content area */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          padding: 0,
        }}
      >
        <Container
          maxWidth={false}
          sx={{
            height: '100%',
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <CodeViewer
            code={code}
            isLoading={isLoading}
            error={error}
            modelType={modelType}
            configPath={configPath}
            onCopy={copyToClipboard}
            onDownload={downloadCode}
          />
        </Container>
      </Box>
    </Box>
  );
};

export default CodeViewerPage;
